import { BigNumber, FixedNumber } from "ethers";
import { commify } from "ethers/lib/utils";

function formatToDisplay(num, round = 5) {
  return commify(FixedNumber.from(num).round(round));
}

function convertToDecimals(amount, multiplierDecimals, divisorDecimals) {
  // e.g. convertToDecimals(2M * 10^6, 18, 6) to convert from 6 decimals to 18
  // 2000000000000 × (10^18) ÷ (10^6) = 2 000 000     000 000 000 000 000 000
  //
  // e.g. convertToDecimals(1111 * 10^18, 6, 18) to convert from 18 decimals to 6
  // 1111111111111111110960 × (10^6) ÷ (10^18) = 1111 111 111

  multiplierDecimals = BigNumber.from(10).pow(multiplierDecimals);
  divisorDecimals = BigNumber.from(10).pow(divisorDecimals);
  return amount.mul(multiplierDecimals).div(divisorDecimals);
}

export { formatToDisplay, convertToDecimals };
